import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SavedSearches = ({ searches, onLoadSearch, onDeleteSearch }) => {
  if (searches?.length === 0) {
    return null;
  }

  return (
    <div className="mb-6 p-4 md:p-6 bg-card border border-border rounded-lg">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-base md:text-lg font-heading font-semibold text-card-foreground">
          Saved Searches
        </h3>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {searches?.map((search) => (
          <div
            key={search?.id}
            className="p-3 bg-muted/50 rounded-lg hover:bg-muted transition-smooth"
          >
            <div className="flex items-start justify-between gap-2 mb-2">
              <h4 className="text-sm font-medium text-card-foreground line-clamp-1">
                {search?.name}
              </h4>
              <button
                onClick={() => onDeleteSearch(search?.id)}
                className="flex-shrink-0 p-1 rounded hover:bg-card transition-smooth"
                aria-label="Delete search"
              >
                <Icon name="Trash2" size={16} color="var(--color-error)" />
              </button>
            </div>
            <p className="text-xs text-muted-foreground mb-3 line-clamp-2">
              {search?.criteria}
            </p>
            <Button
              variant="outline"
              size="sm"
              onClick={() => onLoadSearch(search)}
              fullWidth
              iconName="Search"
              iconPosition="left"
            >
              Load Search
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SavedSearches;